import { FlexRow } from '@make-software/cspr-design';
import styled from 'styled-components';

export const TradeWarningContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    gap: 4,
    padding: '2px 8px',
    borderRadius: 100,
    backgroundColor: `${theme.styleguideColors.contentYellow}1a`, // 1a = 0.1 opacity
  })
);
